/* eslint-disable no-unused-vars */
export default {
  setCurrentSlide({ state, commit }, event) {
    commit('currentSlide', event)
  }
}
